import React from 'react';
import { useNavigate } from 'react-router-dom';
import DynamicFaIcon from '../../atoms/DynamicFaIcon';

interface NavBarPrimaryProps {
    title?: string,
}

const NavBarPrimary = (props: NavBarPrimaryProps) => {
    const { title } = props;
    const navigate = useNavigate();
    return (
        <>
            <nav className="nav-white fixed z-[999]">
                <div className=" flex items-center font-bold gap-2">
                    <button className='p-4 text-center' onClick={() => { navigate(-1) }}>
                        <DynamicFaIcon name={"FaArrowLeft"} />
                    </button>
                    <div className="text-[12px] font-normal">{title}</div>
                </div>
            </nav>
        </>
    );
};

export default NavBarPrimary;